import { Service } from "typedi";
import { BaseService, IBaseService, ServerResponse } from "../../../core/services/BaseService";
import { Appl } from "../../../core/Appl";

export interface ILovService extends IBaseService {

    getListOfValuesAsync(type: string, filter?: string): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class LovService extends BaseService implements ILovService {
    constructor() {
        super(`${Appl.Setting.Services.UtilityServiceUrl}`);
    }

    public async getListOfValuesAsync(type: string, filter?: string): Promise<ServerResponse> {
        try {
            const response = await this.client.get(`/utility/ListOfValue/byTableName/${type}/${filter}`);
            return this.getResponse(response);
        } catch (error: unknown) {
            return await this.getErrorResponse(error);
        }
    }
}